export const REGISTERED_GRID_COMPONENTS = {
    CLICKABLE_COMPONENT: 'clickableGridRowRenderer',
};
